export const commonEmailDomains = [
    'gmail.com',
    'centrum.sk',
    'icloud.com',
    'yahoo.com',
    'hotmail.com',
    'seznam.cz'
] as const;
